import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import HEADPHONES from '../../assets/images/headphones.svg'

const IntroStepUI = ({handleNext}) => (
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', height:'20vh'}}>
  <Typography mt={3} mb={5} className='AxiformaBold' align="center" fontWeight={700} fontSize={'32px'} color={"#5E5E5E"}>
  Understand your tinnitus better with the simple test
  </Typography>
<Box mt={5} sx={{display:'flex' , flexDirection:'column', width:'50vw', height:'30vh', alignItems:'center', justifyContent:'center'}}>
    <img src={HEADPHONES} style={{width:'8vw'}} >
    </img>
    <Typography mt={6} mb={5} className='AxiformaBold' align="center"  fontSize={'24px'} color={"#5E5E5E"}>
  <b>Put on your headphone,</b> find a quiet place, and let's get started! This will only take about <b>5 minutes</b>
  </Typography>
    </Box>
   
    <Button  sx={{width:'30vw', height:'12vh',background:'#424242', radius:'8px', alignItems:'center', color:'white', marginTop:'51px'}} onClick={handleNext}>
      <Typography sx={{fontSize:'24px'}}>Start Test</Typography>  
    </Button>

  </Box>
);

export default IntroStepUI;
